import { AuthContext } from "contexts/auth-context";
import Bank from "page/dashboard/basket/bank";
import React, { useContext, useEffect } from "react";
import { useRedux } from "redux/useRedux";
import { importRetry } from "utils/importTools";
// import DashboardPage from "page/dashboard";
// const DashboardPage = React.lazy(() => importRetry(() => import("page/dashboard")));
const ExamplePage = React.lazy(() => importRetry(() => import("page/dashboard/example")));
const AnalysisPage = React.lazy(() => importRetry(() => import("page/dashboard/analysis/index")));
const AnalysisViewPage = React.lazy(() => importRetry(() => import("page/dashboard/analysis/analysis_page/index")));
const SignalPage = React.lazy(() => importRetry(() => import("page/dashboard/signal/index")));
const SignalSinglePage = React.lazy(() => importRetry(() => import("page/dashboard/signal/single_page/index")));
const BasketPage = React.lazy(() => importRetry(() => import("page/dashboard/basket/basket")));
const AccountPage = React.lazy(() => importRetry(() => import("page/dashboard/account/account")));
const SupportPage = React.lazy(() => importRetry(() => import("page/dashboard/support/index")));
const SupportCreatePage = React.lazy(() => importRetry(() => import("page/dashboard/support/create/index")));
const SupportViewPage = React.lazy(() => importRetry(() => import("page/dashboard/support/view/index")));
const StockPage = React.lazy(() => importRetry(() => import("page/dashboard/stock/index")));
const RiskPage = React.lazy(() => importRetry(() => import("page/dashboard/risk/index")));
const FacilityPage = React.lazy(() => importRetry(() => import("page/dashboard/inquiry/facility/index")));
const BackChequesPage = React.lazy(() => importRetry(() => import("page/dashboard/inquiry/backCheques/index")));
const DrivingOffensePage = React.lazy(() => importRetry(() => import("page/dashboard/inquiry/drivingOffense/index")));
const TransformationPage = React.lazy(() => importRetry(() => import("page/dashboard/transformation/index")));
const AiChatPage = React.lazy(() => importRetry(() => import("page/dashboard/aiChat/index")));
const ResultRiskPage = React.lazy(() => importRetry(() => import("page/dashboard/risk/wighet/result/index")));
const DashboardPage = React.lazy(() => importRetry(() => import("page/dashboard/dashboardView/index")));



export const PanelRoutes = () => {
    const { authState } = useRedux()
    const ctx = useContext(AuthContext);
    useEffect(()=>{
       
    },[])
    return [
        { path: "/dashboard", element: <DashboardPage /> },
        { path: "/analysis", element: <AnalysisPage /> },
        { path: "/analysis/view", element: <AnalysisViewPage /> },
        { path: "/basket", element: <BasketPage /> },
        { path: "/pay-bank", element: <Bank/> },
        // { path: "/signal", element: <SignalPage /> },
        // { path: "/signal/view", element: <SignalSinglePage /> },
        { path: "/account", element: <AccountPage /> },
        { path: "/support", element: <SupportPage /> },
        { path: "/support/create", element: <SupportCreatePage /> },
        { path: "/support/view", element: <SupportViewPage /> },
        // { path: "/stock", element: <StockPage /> },
        { path: "/Inquiry/facility", element: <FacilityPage /> },
        { path: "/Inquiry/backCheques", element: <BackChequesPage /> },
        { path: "/Inquiry/drivingOffense", element: <DrivingOffensePage /> },
        { path: "/transformation", element: <TransformationPage /> },
        { path: "/aichat", element: <AiChatPage /> },
        { path: "/market-suggestion", element: <ResultRiskPage /> },
        { path: "/risk", element: <RiskPage /> },
        // ctx.user?.risk_points !==null&&
      
    
       
    ];
}
